// Old path → new path for renamed routes. Params ($name) carry through by name. Keeps external
// links (SMS, bookmarks, emails) working after a rename — resolved once in the root route's beforeLoad.
const ROUTE_ALIASES: Record<string, string> = {
  "/locations/$locationId/gigs/$gigId/roster": "/locations/$locationId/gigs/$gigId/time-and-attendance",
  "/admin/task-time-upload": "/admin/task-ops/uploads",
  "/locations/$locationId/dashboards": "/locations/$locationId/finance",
  "/locations/$locationId/dashboards/$name": "/locations/$locationId/finance/$name",
  // The API's invoicing Slack deep links are built as `${ADMIN_BASE_URL}/invoicing/…`, without `/admin`.
  "/invoicing/runs": "/admin/invoicing/runs",
  "/invoicing/backfills/$id": "/admin/invoicing/backfills/$id",
};

const compiled = Object.entries(ROUTE_ALIASES).map(([from, to]) => {
  const keys: Array<string> = [];
  const source = from.replaceAll(/\$(\w+)/g, (_, key) => {
    keys.push(key);
    return "([^/]+)";
  });
  return { pattern: new RegExp(`^${source}$`), keys, to };
});

export const resolveAlias = (pathname: string): string | undefined => {
  for (const { pattern, keys, to } of compiled) {
    const match = pattern.exec(pathname);
    if (!match) continue;
    return to.replaceAll(/\$(\w+)/g, (_, key) => match[keys.indexOf(key) + 1]);
  }
  return undefined;
};
